// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_f8-0";
export var actionModalContentContainer = "_f8-1";
export var createTagButton = "_f8-2";
export var footerContainer = "_f8-7";
export var fullWidthDivider = "_f8-3";
export var hasCreateTagButton = "_f8-4";
export var noCreateTagButton = "_f8-5";
export var tagsContainer = "_f8-6";
export var tagsModalContentContainer = "_f8-8";